/* eslint-disable react/react-in-jsx-scope */
/** @jsx h */

import { h, Fragment } from 'preact';
import './index.global.css';
import '../../../tiled-header';

export const introRenderer = (variant = 'control') => () => (
  <upd-tiled-header>
    <div class="home-services-intro__body">
      <div class="home-services-intro__subtitle">Recommended First Step</div>
      <div class="home-services-intro__line" />
      {variant === 'control' && (
        <Fragment>
          <div class="home-services-intro__title">Connect TV & Internet</div>
          <div class="home-services-intro__copy">
            We recommend completing this first based on your move date.
          </div>
        </Fragment>
      )}

      {variant === 'connect' && (
        <Fragment>
          <div class="home-services-intro__title">Connect TV & Internet</div>
          <div class="home-services-intro__copy">
            Don't waste time on the phone with the cable company. Find the best
            price on the best plan for you in seconds.
          </div>
        </Fragment>
      )}

      {variant === 'set_up' && (
        <Fragment>
          <div class="home-services-intro__title">Set up WiFi & Cable</div>
          <div class="home-services-intro__copy">
            Don't waste time on the phone with the cable company. Find the best
            price on the best plan for you in seconds.
          </div>
        </Fragment>
      )}
    </div>
  </upd-tiled-header>
);
